export default __webpack_public_path__ + "static/media/Cinema.89ea3373.svg";